<script setup lang="ts">
import { computed } from 'vue';
import { Location } from '@/modules/content-blocks/interfaces/location-block.interface';
import { formatAddress } from '@/modules/content-blocks/helpers/location-block.helper';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';

const props = defineProps<{
   location: Location;
}>();

const emit = defineEmits<{
   (e: 'onSelectLocation', locationId: string): void;
}>();

const formattedAddress = computed(() => formatAddress(props.location.address));
const jobBoardStore = useJobBoardStore();
const activeLang = computed(() => jobBoardStore.activeLanguageName);

const handleClick = () => {
   if (!formattedAddress.value) return;
   emit('onSelectLocation', props.location.id);
};
</script>

<template>
   <div class="location-card" @click="handleClick">
      <h3 v-if="location.title?.[activeLang]" class="location-card__title">{{ location.title[activeLang] }}</h3>
      <div class="location-card__details">
         <div v-if="formattedAddress">{{ formattedAddress }}</div>
         <div v-if="location.email">
            <a :href="`mailto:${location.email}`">{{ location.email }}</a>
         </div>
         <div v-if="location.phone">
            <a :href="`tel:${location.phone}`">{{ location.phone }}</a>
         </div>
      </div>
   </div>
</template>

<style scoped lang="scss">
.location-card {
   border: 1px solid var(--nxt-light-grey);
   border-radius: var(--nxt-radius);
   padding: var(--nxt-gutter-large);
   cursor: pointer;

   &:hover,
   &.is-selected {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
   }

   &__title {
      margin: 0 0 var(--nxt-gutter) 0;
      color: var(--nxt-dark);
   }

   &__details {
      display: flex;
      flex-direction: column;
      color: var(--nxt-medium-dark);
      gap: var(--nxt-gutter-small);
   }
}
</style>
